import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=515debe2&scoped=true"
import script from "./factory.vue?vue&type=script&lang=js"
export * from "./factory.vue?vue&type=script&lang=js"
import style0 from "./factory.vue?vue&type=style&index=0&id=515debe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515debe2",
  null
  
)

export default component.exports